<template>
    <div>
      <div id="page_wrapper">
        <div id="contents">
          <div id="sub_head">
            <ul class="pan">
              <li><a href="/">ホーム</a>&gt;</li>
              <li><a href="../">建築</a>&gt;</li>
              <li v-if="isIndex">建築基礎構造マップ​</li>
              <li v-if="isResult"><a href="./">建築基礎構造マップ​</a>&gt;</li>
              <li v-if="isResult">建築基礎構造検索結果​</li>
            </ul>
          </div>
          <!-- /sub_head -->
          <h2 class="h2_type01">建築基礎構造マップ</h2>
        </div>
        <!-- /contents -->
        <div id="sub_side">
          <h3 class="mb30"><img src="/kenchiku/images/title.png" width="210" height="356" border="0" alt="建築" /></h3>
        </div>
        <!-- /sub_side -->
      </div>
      <!-- /page_wrapper -->

      <!--index_list_head-->
      <div id="wide_contents">
        <div v-if="isIndex">
          <p class="mb20">有名な建物の基礎構造について調査し、リーフレットを作成しました。下のマップから検索・リーフレットの閲覧ができます。</p>
          <div class="structure_map">
            <div ref="gmap" id="map" class="map-index"></div>
          </div>
        </div>
        <div v-if="isResult" class="structure_map-head" style="text-align: center;font-weight: bold;">
          <div class="notice">{{list.length}}件見つかりました</div>
        </div>
        <div v-if="isResult" class="structure_map">
          <div id="map" class="map-result"></div>
          <div class="result_listBox">
            <ul class="result_listWrap">
              <li v-if="isEmptyList" class="result_list">
                <div class="result_listContent">
                  <p class="result_listContent_txt">検索結果はありません。</p>
                </div>
              </li>
              <li v-if="!isEmptyList" v-for="(v,i) in list" :key="v.sheet_no" :class="resListClass(i)">
                <div :class="listNumClass(v)">{{i+1}}</div>
                <div class="result_listContent">
                  <a href="#" class="result_listContent_ttl" @click.prevent="setMapCenter(v.latlng,i)">{{v.title}}</a>
                  <a href="#" target="_blank" class="result_listContent_ttl pdf" @click.prevent="openPdf(v.sheet_no)">&nbsp;&nbsp;[PDF]<span class="pdf_link">&nbsp;</span></a>
                  <div class="result_listContent_txt">{{v.address}}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div id="search_container">
          <div class="box_inner">
            <div id="form_how" class="formset">
              <form ref="form1" id="structuremap" name="structuremap" action="./">
                <h4>条件検索</h4>
                <div class="flexbox mb30 spmb0">
                  <div class="box col2">
                    <h5>■都道府県</h5>
                    <select id="company" name="pref" v-model="item.pref">
                      <option value="" selected="selected">お選びください</option>
                      <option v-for="p in prefList" :key="p" :value="p">{{p}}</option>
                    </select>
                  </div>
                  <!--box-->
                <div class="box col2 flexbox start spmb0">
                  <h5>■竣工年<span class="txt_small">（西暦を半角数字で入力してください）</span></h5>
                  <div class="flexbox  start">
                    <div class="box col1 w100"><input type="text" id="construction_year1" name="completion_year_start" style="width: 5em;" v-model="item.completion_year_start"> 年　～　
                      <input type="text" id="construction_year2" name="completion_year_end" style="width: 5em;" v-model="item.completion_year_end"> 年
                    </div>
                  </div>
                </div>
                  <!--box-->
                </div>

                <div class="box mb30 flexbox start spmb0">
                  <h5>■施工者​</h5>
                  <div class="flexbox  start">
                    <div class="box col1 w100">
                      <input type="text" id="vender" name="constructor" style="width: 10em;" v-model="item.constructorStr">
                    </div>
                  </div>
                  <!--box-->
                </div>

                <div class="box mb30">
                  <h5>■基礎形式</h5>
                  <ol class="flexbox start gap20">
                    <li><input type="checkbox" name="basic_form_1" id="construction_classification_1" v-model="item.basic_form_1">
                      <label for="construction_classification_1">直接基礎</label></li>
                    <li><input type="checkbox" name="basic_form_2" id="construction_classification_2" v-model="item.basic_form_2">
                      <label for="construction_classification_2">杭基礎</label></li>
                    <li><input type="checkbox" name="basic_form_3" id="construction_classification_5" v-model="item.basic_form_3">
                      <label for="construction_classification_3">その他</label></li>
                  </ol>
                  <!--box-->
                </div>

                <div class="box mb30">
                  <h5>■建築形式</h5>
                  <ol class="flexbox start gap20">
                    <li><input type="checkbox" name="skyscraper" id="architectural_1" v-model="item.skyscraper">
                      <label for="architectural_1">超高層建築</label></li>
                    <li><input type="checkbox" name="large_space" id="architectural_2" v-model="item.large_space">
                      <label for="architectural_2">大空間建築</label></li>
                  </ol>
                  <!--box-->
                </div>

                <p class="btn_container"><input type="image" id="submit_2" src="/common/images/btn_search02.jpg" name="submit" @click.prevent="openResult"> <span class="mt10 clearbtn" @click.prevent="clearForm">条件をクリア</span></p>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
/**
 * 参考ページ
 * https://qiita.com/buuibuui/items/25a75127cbc9ece9a0fb
 */
import GoogleMapNKR from './GoogleMapNKR.js';

export default {
  data: () => { return {
    mode: "index", // ページタイプ index | result
    gmapNkr: null,
    prefList: [],
    currentIndex: -1, // 現在のインデックス
    BASE_MAP_CENTER: {lat: 35.68673633210552, lng: 139.75306858890443}, // 皇居
    PRE_MAP_CENTER: {lat: 35.68673633210552, lng: 139.75306858890443}, // 初期位置（indexページでは現在位置を取得して設定する）
    locations_org: [],
    locations: [],
    lati: "",
    long: "",
    address: "",
    item: {
      pref                  : "",
      completion_year_start : "",
      completion_year_end   : "",
      constructorStr        : "",
      basic_form_1          : false,
      basic_form_2          : false,
      basic_form_3          : false,
      skyscraper            : false,
      large_space           : false,
    },
    list: [],
  };},
  created() {
    this.parseUrlParams();
    this.loadItem();
  },
  methods: {
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    parseUrlParams() {
      const varsStr = {
        pf: "pref"                  ,
        ys: "completion_year_start" ,
        ye: "completion_year_end"   ,
        ct: "constructorStr"        ,
      };
      const varsBool = {
        b1: "basic_form_1"          ,
        b2: "basic_form_2"          ,
        b3: "basic_form_3"          ,
        sc: "skyscraper"            ,
        ls: "large_space"           ,
      };

      // URLのパラメータを解析して、itemに設定する
      const params = new URLSearchParams(window.location.search);
      this.mode = (params.has("md") && params.get("md") === "res") ? "result" : "index";
      for (let key in varsStr) {
        const name = varsStr[key];console.log("PARAMS1", key, name);
        if (params.has(key)) { console.log("PARAMS2", key);
          this.item[name] = params.get(key);
        }
      }
      for (let key in varsBool) {
        const name = varsBool[key];
        if (params.has(key)) {
          this.item[name] = (params.get(key) == 1);
        }
      }
    },
    // 現在位置を取得し、PRE_MAP_CENTERに設定する
    async getCurrentPosition() {
      const errorCallback = (error) => {
        console.error("位置情報取得エラー:", error);
        this.gmapPostInit( this.PRE_MAP_CENTER );
      };

      const successCallback = (position) => {
        this.PRE_MAP_CENTER = {lat: position.coords.latitude, lng: position.coords.longitude};
        this.gmapPostInit( this.PRE_MAP_CENTER );
      };

      // getCurrentPositionのオプション
      let options = {
        enableHighAccuracy: true,
        timeout: 5000,
        maximumAge: 0
      };

      // 位置情報を取得
      navigator.geolocation.getCurrentPosition(successCallback, errorCallback, options);
    },
    async loadItem()
    {
      let apiURL = "./apis/get_list.php";
      if( location.href.indexOf("local") >= 0 ) {
        // 開発環境用
        apiURL = "https://local.new.www.nikkenren.com/kenchiku/structuremap/apis/get_list.php";
      }

      let res;
      if( this.isResult ) {
        // 検索結果表示モード
        const fd = new FormData();
        fd.append("params", JSON.stringify(this.item));

        res = await(await fetch( apiURL, {
          method: "POST",
          body: fd,
        })).json();
      }
      else {
        // 初期表示は全リスト
        res = await(await fetch( apiURL )).json();
      }

      console.log( "RES", res );

      this.prefList.splice( 0 );
      res.prefList.forEach( item => {
        this.prefList.push( item );
      });

      res.list.forEach( item => {
        for( let name in item ) {
          if( ["basic_form_1","basic_form_2","basic_form_3","skyscraper","large_space","no_existence"].indexOf(name) !== -1 ) {
            item[name] = (item[name] == 1);
          }
        }
        this.list.push( item );
      });

      await this.googleMapInit();
    },
    async googleMapInit()
    {
      this.gmapNkr = new GoogleMapNKR('map', 12);
      this.locations_org.splice(0);
      this.locations.splice(0);

      if( this.isIndex ) {
        // indexページの場合は、初期位置を現在位置とする
        await this.getCurrentPosition();
      }

      if( this.isResult ) {
        this.gmapPostInit();
      }
    },
    async gmapPostInit() {
      // GoogleMapNKRの初期化後に呼び出される
      await this.gmapNkr.init( this.PRE_MAP_CENTER );
      if( this.list.length === 0 ) return;
      this.gmapNkr.markerSet(this.list, this.isResult);

      let mapCenterPos = this.PRE_MAP_CENTER;
      if(this.isResult && this.list.length > 0) {
        let t = this.getLatLngObject(this.list[0].latlng);
        mapCenterPos = {lat: t.lat(), lng: t.lng()};
      }

      this.gmapNkr.setMapCenter(mapCenterPos.lat, mapCenterPos.lng);
    },
    setMapCenter( latlng, index ) {
      this.currentIndex = index;

      const c = this.getLatLngObject( latlng );
      this.gmapNkr.setMapCenter(c.lat(), c.lng());
      this.gmapNkr.openInfoWindow( index );
    },
    openPdf(sheet_no) {
      // PDFを新しいタブで開く
      const url = "./pdf/" + sheet_no + ".pdf";
      window.open(url, "_blank");
    },
    getLatLngObject( latlng ) {
      return this.gmapNkr.getLatLngObject(latlng);
    },
    openResult() {
      if( !this.validateInput() ) {
        return;
      }

      let params = {};
      let isParams = false;
      for( let name in this.item ) {
        if( ["pref","completion_year_start","completion_year_end","constructorStr"].indexOf(name) !== -1 ) {
          if( this.item[name] !== "" ) {
            params[this.itemName2ParamName(name)] = this.item[name];
            isParams = true;
          }
        }
        if( ["basic_form_1","basic_form_2","basic_form_3","skyscraper","large_space"].indexOf(name) !== -1 ) {
          if( this.item[name] === true ) {
            params[this.itemName2ParamName(name)] = 1;
            isParams = true;
          }
        }
      }

      location.href = (isParams)
        ? "./?md=res&" + new URLSearchParams(params).toString()
        : "./?md=res";
    },
    validateInput() {
      if( this.item.completion_year_start !== "" && isNaN(this.item.completion_year_start) ) {
        alert("施工年は半角数字で入力してください。");
        return false;
      }
      if( this.item.completion_year_end !== "" && isNaN(this.item.completion_year_end) ) {
        alert("施工年は半角数字で入力してください。");
        return false;
      }
      return true;
    },
    clearForm() {
      this.item.pref                  = "";
      this.item.completion_year_start = "";
      this.item.completion_year_end   = "";
      this.item.constructorStr        = "";
      this.item.basic_form_1          = false;
      this.item.basic_form_2          = false;
      this.item.basic_form_3          = false;
      this.item.skyscraper            = false;
      this.item.large_space           = false;
    },
    itemName2ParamName( itemName ) {
      switch( itemName ) {
        case "pref"                 : return "pf";
        case "completion_year_start": return "ys";
        case "completion_year_end"  : return "ye";
        case "constructorStr"       : return "ct";
        case "basic_form_1"         : return "b1";
        case "basic_form_2"         : return "b2";
        case "basic_form_3"         : return "b3";
        case "skyscraper"           : return "sc";
        case "large_space"          : return "ls";
      }
      return itemName;
    },
    resListClass( index ) {
      return (this.currentIndex === index) ? "result_list checked" : "result_list";
    },
    listNumClass( v ) {
      let className = "result_listNum";
      if( v.basic_form_1 ) {
        className += " basic_form_1";
      }
      else if( v.basic_form_2 ) {
        className += " basic_form_2";
      }
      else if( v.basic_form_3 ) {
        className += " basic_form_3";
      }
      return className;
    }
  },
  computed: {
    isIndex() {
      return this.mode === "index";
    },
    isResult() {
      return this.mode === "result";
    },
    isEmptyList() {
      return this.list.length === 0;
    },
    subTitle() {
      if( this.isResult ) {
        document.title = "建築基礎構造検索結果​ | 日本建設業連合会";
        return "建築基礎構造検索結果​";
      }
      return "建築基礎構造マップ​";
    },
  }
}
</script>

<style scoped>

/* width, height設定しないと地図が表示されませんでした。 */
.map-index {
  width: 1000px;
  height: 400px;
}
.map-result {
  width: 680px;
  height: 400px;
}
</style>
